import styled from 'styled-components';

export const ErrorPageContainer = styled.div`
  display: flex;
  flex-direction: column; 
  flex: 1;
`;

export const ErrorContent = styled.div`
  margin: 20px auto;
  width: 800px;
  padding: 0 20px;
  flex: 1;
`;



// WEBPACK FOOTER //
// ./src/screens/error-page/styles.tsx